import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { VerticalCardComponent } from '@app/library/panes/grid-card-universal/vertical/vertical-card.component';
import { AbstractPane } from '@app/library/panes/models/abstract-pane';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { Store } from '@ngrx/store';

import { Content } from 'lingo2-models';

@Component({
  selector: 'app-new-simple-title',
  templateUrl: './new-simple-title.component.html',
  styleUrls: ['./new-simple-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    LocaleSharedModule,
    CommonModule,
    SpinnersModule,
    LibraryElementsModule,
    ScrollingModule,
    ModalModule,
    MobileModalModule,
    VerticalCardComponent,
  ],
})
export class NewSimpleTitleComponent extends AbstractPane implements OnInit {
  public item: Content;
  public isSmallScreen = true;

  protected router = inject(Router);
  protected location = inject(Location);
  protected store = inject(Store);

  ngOnInit() {}

  public hasContent(): boolean {
    return true;
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    this.isVisible = true;
  }

  public trackContentByFn(index, item: Content): string {
    return item.id;
  }
}
